import React, { forwardRef } from "react";
import { FormFieldContainer } from "@/components/form/field/container";
import { FormFieldInfo } from "@/components/form/field/info";
import type { FormFieldLabel } from "@/components/form/field/label";
import { PhoneInput } from "@/components/ui/phone-input";
import { useFieldContext } from "@/form/common/hook";
import { AppFormFieldLabel, type AppFormFieldLabelProps } from "@/form/components/field-label";
import type { AppFormFieldProps } from "@/form/components/types";
import { cn } from "@/lib/style/cva.config";

export type PhoneFieldProps = AppFormFieldLabelProps & {
  helperText?: string;
  parts?: {
    container?: React.ComponentProps<typeof FormFieldContainer>;
    label?: React.ComponentProps<typeof FormFieldLabel>;
  };
};

export const PhoneField = forwardRef<
  React.ElementRef<typeof PhoneInput>,
  React.ComponentProps<typeof PhoneInput> & AppFormFieldProps & PhoneFieldProps
>(function PhoneField({ helperText, parts, ...props }, ref) {
  const field = useFieldContext<string>();

  return (
    <FormFieldContainer {...parts?.container}>
      <AppFormFieldLabel
        field={field}
        required={props.required}
        disabled={props.disabled}
        name={props.name}
        {...parts?.label}
      />
      <PhoneInput
        ref={ref}
        {...props}
        name={field.name}
        value={field.state.value}
        onChange={field.handleChange}
        onBlur={field.handleBlur}
        className={cn("bg-surface-neutral", props.className)}
      />
      <FormFieldInfo field={field} children={helperText} />
    </FormFieldContainer>
  );
});
